import { useAtomValue } from 'jotai'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import DisposalTrendWrapper from '@/components/disposal-trend/wrapper'
import { selectedCollectionPointIdAtom } from '@/state'
import HistoryReturnButton from '@/components/history-return-button'

function DisposalTrendView() {

    const collectionPointId = useAtomValue(selectedCollectionPointIdAtom)

    const title = 'Trend výsypu svozového místa'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box>
                    <HistoryReturnButton />
                </Box>
                <Typography variant="h2" component="h1" gutterBottom>
                    {title}
                </Typography>
                {collectionPointId ?
                    <DisposalTrendWrapper />
                    :
                    <Box>
                        Vyberte prosím konkrétní svozové místo výše.
                    </Box>
                }
            </CustomPaper>
        </>
    )
}

export default DisposalTrendView
